import { createMutation } from '@/mutations'
import { useTokenStore } from '@/features/auth/store'
import {
  changePassword,
  requestEmailChange,
  resendEmailVerification,
} from '@/features/profile/api/account'

export const useRequestEmailChangeMutation = () => {
  return createMutation<void, string>({
    mutationFn: (newEmail) => requestEmailChange(newEmail),
  })
}

/** Decision 15 — the answer's tokens replace this device's session (the old token is revoked). */
export const useChangePasswordMutation = () => {
  return createMutation<void, { currentPassword: string; newPassword: string }>({
    mutationFn: async ({ currentPassword, newPassword }) => {
      const tokens = await changePassword(currentPassword, newPassword)
      if (tokens) useTokenStore().setTokens(tokens)
    },
  })
}

export const useResendEmailVerificationMutation = () => {
  return createMutation<void, void>({
    mutationFn: () => resendEmailVerification(),
  })
}
